import { computed, Ref, ComputedRef } from '@vue/composition-api';
import { keyEnumObject, KeyTypeOf } from '@berlin-front/common/utils';

/**
 * ボタンサイズ種別
 */
export const BUTTON_SIZE_MAP = {
  default: '44px',
  high: '52px',
  low: '40px',
} as const;

/**
 * ボタンサイズ種別定数
 */
export const BUTTON_SIZE = keyEnumObject(BUTTON_SIZE_MAP);

/**
 * ボタンサイズタイプ
 */
export type ButtonSize = KeyTypeOf<typeof BUTTON_SIZE_MAP>;

/**
 * ボタンサイズを使用する。
 */
export const useButtonSize = (buttonSize: Ref<ButtonSize>): ComputedRef<string> =>
  computed(() => BUTTON_SIZE_MAP[buttonSize.value]);
